import { graphql } from "react-relay";

export const PAGE_FRAGMENT = graphql`
	fragment messagePageFormDialog_PageFragment on MessageDefinitionPage {
		internalTitle
		...messagePageForm_PageFragment
	}
`;
